/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Group, OptionsFilter, Select } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconRefresh, IconTruck } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { VehicleType } from '../../../models/core/vehicles.type';
import vehiclesService from '../../../services/core/vehicles.service';
import theme from '../../../theme';
import { SessionStorageKey } from '../../../utils/constants.utils';
import { transformComboBoxGroupDataFromV5toV7 } from '../../../utils/mantine.utils';
import ProfileCardLink from '../ProfileCardLink/ProfileCardLink';

type FormViewProps = {
  label: string;
  formItem: any;
  idsToBeDisabled: number[];
  disabled: boolean;
  callback(item: VehicleType | null): void;
  zIndex: number;
  useCache: boolean;
};

export default function VehiclePicker(props: FormViewProps) {
  const [data, setData] = useState<VehicleType[]>([]);
  const [loading, setLoading] = useState(false);

  const confirmActionResult = (item: VehicleType | null, confirmed: boolean) => {
    if (!confirmed) {
      return;
    }
    props.callback(item);
  };

  const loadData = async () => {
    try {
      setLoading(true);
      const result = await vehiclesService.list();
      setData(result);
      sessionStorage.setItem(`${SessionStorageKey.VehicleSearch}`, JSON.stringify(result));
    } catch (error: any) {
      showNotification({
        title: `Veículos`,
        message: error?.isBusinessException ? error.description : 'Não foi possível listar os veículos.',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.useCache) {
      const cacheResult = JSON.parse(
        sessionStorage.getItem(`${SessionStorageKey.VehicleSearch}`) || '[]'
      ) as VehicleType[];

      if (cacheResult.length > 0) {
        setData(cacheResult);
      } else {
        loadData();
      }
    } else {
      loadData();
    }
  }, []);

  const handleRefresh = () => {
    loadData();
  };

  const optionsFilter: OptionsFilter = ({ options, search }) => {
    if (search.trim().length === 0) {
      return options;
    }

    const filteredData = data
      .filter((x) => {
        const value = `${x.idResiduoVeiculo}|${x.residuoVeiculo}|${x.descricao}`;
        return value.toLowerCase().includes(search.toLowerCase());
      })
      .map((y) => y.idResiduoVeiculo?.toString());

    const filteredOptions = [];
    for (const option of options) {
      const items = (option as any).items.filter((x: any) => filteredData.includes(x.value));
      if (items.length > 0) {
        filteredOptions.push({
          ...option,
          items,
        });
      }
    }
    return filteredOptions;
  };

  return (
    <Group grow preventGrowOverflow={false} wrap="nowrap">
      <Select
        key={`vehicle-picker_${props.formItem.value?.toString()}`}
        leftSection={<IconTruck size={15} />}
        label={props.label}
        placeholder="Selecione..."
        data={transformComboBoxGroupDataFromV5toV7(
          data.map((x) => {
            return {
              label: `# ${x.idResiduoVeiculo} - ${x.residuoVeiculo}`,
              value: x.idResiduoVeiculo.toString(),
              disabled: props.idsToBeDisabled.includes(x.idResiduoVeiculo),
              group: x.residuoVeiculo.toUpperCase()[0],
            };
          })
        ).sort((a, b) => a.group.localeCompare(b.group))}
        clearable
        searchable
        filter={optionsFilter}
        disabled={props.disabled || loading}
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        renderOption={({ option, checked }) => {
          const row = data.find((x) => x.idResiduoVeiculo.toString() === option.value)!;
          return (
            <ProfileCardLink
              id={row.idResiduoVeiculo.toString()}
              name={row.residuoVeiculo}
              nameSize="sm"
              description={row.descricao}
              descriptionSize="xs"
              linkPrefix="vehicles"
              showLink={false}
            />
          );
        }}
        required
        {...props.formItem}
        value={props.formItem.value?.toString()}
        onOptionSubmit={(value: string) => {
          confirmActionResult(data.find((x) => x.idResiduoVeiculo.toString() === value) || null, true);
        }}
        comboboxProps={{ zIndex: props.zIndex + 1 }}
      />
      <ActionIcon
        style={{ marginLeft: -10, marginTop: 20, maxWidth: 15 }}
        radius="sm"
        color="primary"
        variant="outline"
        onClick={handleRefresh}
        disabled={props.disabled || loading}
        loading={loading}
      >
        <IconRefresh size={15} color={theme?.colors?.primary?.[6]} />
      </ActionIcon>
    </Group>
  );
}
